import React, { useState, useEffect } from 'react'
import { FormGroup, ControlLabel, Input, Radio, RadioGroup } from 'rsuite'
import classNames from 'classnames'
import { isValidators, isRequired } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../message/errorMessage/ErrorMessage'
import COIValidateWidget from '../../../widgets/coi/COIValidateWidget'
// import './styles.less'

export default function ProposalFilterSummaryForm({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  reset,
  clearErrors,
}) {
  const [schema, setSchema] = useState(_schema)
  const [isCheckCOI, setIsCheckCOI] = useState(false)
  const [isCOIPass, setIsCOIPass] = useState(false)
  const [checkCOI, setCheckCOI] = useState(false)

  return (
    <>
      <FormGroup>
        <ControlLabel
          className={classNames(
            'style-text-lable',
            isRequired(schema.filterSummary.validators) && 'required'
          )}
        >
          {schema.filterSummary.label}
        </ControlLabel>
        <ErrorMessage error={errors.filterSummary} />
        <Input
          name={schema.filterSummary.name}
          defaultValue={schema.filterSummary.value || ''}
          componentClass="textarea"
          placeholder={schema.filterSummary.hint || `ระบุ${schema.filterSummary.label}`}
          inputRef={register(isValidators(schema.filterSummary.validators))}
          disabled={schema.filterSummary.disabled}
        />
      </FormGroup>

      <Controller
        name={schema.proposalFilter.name}
        control={control}
        defaultValue={'1'}
        rule={register(isValidators(schema.proposalFilter.validators))}
        render={(props) => {
          return (
            <RadioGroup
              value={props.value}
              onChange={(value) => {
                props.onChange(value)
              }}
            >
              {schema.proposalFilter.options.map((item) => (
                <Radio
                  key={item.value}
                  value={item.value}
                  disabled={schema.proposalFilter.disabled}
                >
                  {item.label}
                </Radio>
              ))}
            </RadioGroup>
          )
        }}
      />
    </>
  )
}
